import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-218e4e9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["TableauPopup"], {
    ref: "popup",
    width: 400,
    title: "Manage My Role",
    submitText: "Change Role",
    status: $setup.status,
    statusMessage: $setup.statusMessage,
    canSubmit: $setup.canSubmit,
    onSubmitted: $setup.submit
  }, {
    default: _withCtx(() => [
      _createVNode($setup["TableauRadioGroup"], {
        title: `Select your desired role for site '${
        $props.info.siteName || 'Default'
      }':`,
        modelValue: $setup.selectedRole,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedRole) = $event)),
        possibleValues: $setup.possibleValues,
        allDisabled: $setup.status === 'loading' || $setup.status === 'success'
      }, null, 8 /* PROPS */, ["title", "modelValue", "possibleValues", "allDisabled"]),
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" You can read about Tableau Server Roles "),
        _createVNode($setup["TableauLink"], {
          href: "https://help.tableau.com/current/server/en-us/users_site_roles.htm#tableau-site-roles-as-of-version-20181",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode("here")
          ]),
          _: 1 /* STABLE */
        }),
        _createTextVNode(". ")
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["status", "statusMessage", "canSubmit"]))
}